import React from "react";
import SEO from "@/components/SEO";
import { PageHero, CTABand } from "@/components/PageHero";
import { Section, SectionHeading, InfoBox } from "@/components/Primitives";
import { ShieldCheck, Globe2, Users, Handshake, Target, BadgeCheck } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const BLOCKS = [
  { icon: Users, title: "Who We Are", text: "Global Pass Consultants was created to help entrepreneurs move beyond simple company registration. We connect company setup with market entry, compliance, business development and international expansion." },
  { icon: Globe2, title: "Malaysia Headquarters", text: "Headquartered in Malaysia with a special focus on Labuan IBFC, we help international founders establish and operate credible business structures." },
  { icon: Target, title: "Global Service Network", text: "We coordinate support across Malaysia, Canada, the United Kingdom, Pakistan and India through appropriately licensed and regulated professional partners." },
  { icon: Handshake, title: "Our Approach", text: "Business-first. We assess the commercial side before any immigration planning, and we are honest about what is and is not guaranteed." },
  { icon: BadgeCheck, title: "Professional Partner Network", text: "Regulated legal, tax, trust company and immigration services are provided by or referred to appropriately licensed professionals." },
  { icon: ShieldCheck, title: "Compliance Commitment", text: "We prioritise due diligence, transparency and compliance at every stage. No outcome is guaranteed." },
];

const TEAM = [
  { name: "[Team member — configure before launch]", role: "Managing Consultant" },
  { name: "[Team member — configure before launch]", role: "Labuan Advisory Lead" },
  { name: "[Team member — configure before launch]", role: "Global Expansion Advisor" },
];

export default function About() {
  return (
    <>
      <SEO title="About Us" description="Global Pass Consultants connects company setup with market entry, compliance and international expansion. Contact us to know more." path="/about" />
      <PageHero eyebrow="About Us" image={IMG} title="A Serious International Business Advisory Firm"
        subtitle="We help entrepreneurs move beyond simple company registration — connecting setup with compliance, business development and global expansion." />

      <Section className="bg-white">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOCKS.map((b) => (
            <div key={b.title} className="rounded-2xl border border-slate-100 bg-slate-50/60 p-7 hover-lift">
              <div className="w-12 h-12 rounded-xl bg-navy/5 flex items-center justify-center mb-4"><b.icon className="text-navy" /></div>
              <h3 className="font-bold text-navy text-lg">{b.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{b.text}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section className="bg-slate-50">
        <SectionHeading eyebrow="Leadership Team" title="Our People" center
          subtitle="Team profiles are shown as clearly-marked placeholders and will be confirmed before launch." />
        <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {TEAM.map((t) => (
            <div key={t.role} className="rounded-2xl bg-white border border-slate-100 p-6 text-center">
              <div className="w-20 h-20 rounded-full bg-navy text-gold flex items-center justify-center mx-auto text-2xl font-bold">GP</div>
              <div className="mt-4 font-bold text-navy text-sm">{t.name}</div>
              <div className="text-xs text-emerald-brand font-semibold">{t.role}</div>
            </div>
          ))}
        </div>
        <div className="mt-8 max-w-3xl mx-auto"><InfoBox>We do not invent years of experience, client numbers, awards, certifications, staff or partners. Company facts are shown as static placeholders until confirmed. Contact us to know more.</InfoBox></div>
      </Section>

      <CTABand />
    </>
  );
}
